export default __webpack_public_path__ + "static/media/22_TopLeftSquares_Bottom.4b585eb2.mp4";